import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Add auth token to requests
api.interceptors.request.use((config) => {
  // Check for admin token first for admin routes
  const adminToken = localStorage.getItem('mrs_admin_token');
  const userToken = localStorage.getItem('mrs_token');
  
  if (config.url?.includes('/admin') && adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (userToken) {
    config.headers.Authorization = `Bearer ${userToken}`;
  }
  return config;
});

// Public endpoints
export const fetchSiteConfig = () => api.get('/site-config').then(r => r.data);
export const fetchPresale = () => api.get('/presale').then(r => r.data);
export const fetchTokenomics = () => api.get('/tokenomics').then(r => r.data);
export const fetchContent = () => api.get('/content').then(r => r.data);
export const fetchSocialLinks = () => api.get('/social-links').then(r => r.data);
export const fetchDepositWallets = () => api.get('/deposit-wallets').then(r => r.data);
export const fetchAirdropConfig = () => api.get('/airdrop-config').then(r => r.data);

// Auth
export const registerUser = (data) => api.post('/auth/register', data).then(r => r.data);
export const loginUser = (data) => api.post('/auth/login', data).then(r => r.data);
export const getMe = () => api.get('/auth/me').then(r => r.data);
export const updateProfile = (data) => api.put('/auth/profile', data).then(r => r.data);
export const changePassword = (data) => api.put('/auth/password', data).then(r => r.data);

// User
export const createOrder = (data) => api.post('/orders', data).then(r => r.data);
export const getOrders = () => api.get('/orders').then(r => r.data);
export const getTransactions = () => api.get('/transactions').then(r => r.data);
export const claimAirdrop = (data) => api.post('/airdrop/claim', data).then(r => r.data);

// Admin
export const adminLogin = (data) => api.post('/admin/login', data).then(r => r.data);
export const adminUpdatePresale = (data) => api.put('/admin/presale', data).then(r => r.data);
export const adminUpdateTokenomics = (data) => api.put('/admin/tokenomics', data).then(r => r.data);
export const adminUpdateContent = (data) => api.put('/admin/content', data).then(r => r.data);
export const adminUpdateSocialLinks = (data) => api.put('/admin/social-links', data).then(r => r.data);
export const adminUpdateDepositWallets = (data) => api.put('/admin/deposit-wallets', data).then(r => r.data);
export const adminUpdateSiteConfig = (data) => api.put('/admin/site-config', data).then(r => r.data);
export const adminUpdateAirdropConfig = (data) => api.put('/admin/airdrop-config', data).then(r => r.data);
export const adminGetOrders = () => api.get('/admin/orders').then(r => r.data);
export const adminUpdateOrder = (id, data) => api.put(`/admin/orders/${id}`, data).then(r => r.data);
export const adminGetUsers = () => api.get('/admin/users').then(r => r.data);
export const adminGetAirdropClaims = () => api.get('/admin/airdrop-claims').then(r => r.data);
export const adminUpdateUser = (id, data) => api.put(`/admin/users/${id}`, data).then(r => r.data);
export const adminDeleteUser = (id) => api.delete(`/admin/users/${id}`).then(r => r.data);
export const adminChangePassword = (data) => api.put('/admin/password', data).then(r => r.data);

// Password Reset
export const forgotPassword = (data) => api.post('/auth/forgot-password', data).then(r => r.data);
export const resetPassword = (data) => api.post('/auth/reset-password', data).then(r => r.data);

export default api;
